import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { clearSessionExpiredFlag, isSessionExpiredSync } from '../utils/authSession';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isSessionExpired, setIsSessionExpired] = useState(() => isSessionExpiredSync());

    useEffect(() => {
        const handleSessionExpired = () => setIsSessionExpired(true);
        window.addEventListener('session-expired', handleSessionExpired);
        return () => window.removeEventListener('session-expired', handleSessionExpired);
    }, []);

    const clearSessionExpired = useCallback(() => {
        clearSessionExpiredFlag();
        setIsSessionExpired(false);
    }, []);

    return (
        <AuthContext.Provider value={{ isSessionExpired, clearSessionExpired }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
